const source = 'podsDataTable'

function getModificaMassivaMethod () {
  const keys = Object.keys(this.filtered.ids).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.ids[source].map((el) => el.value)
    
    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-modifica-massiva',
      title: 'Modifica Massiva Pods',
      data: ids,
      maximize: false,

      buttonOk: {
        label: 'Chiudi',
        icon: 'pi pi-times',
        class: 'p-button-text',
        visible: true,
        disabled: false,
      },
  
      buttonCancel: {
        label: '',
        icon: '',
        class: '',
        visible: false,
        disabled: false,
      },
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': getModificaMassivaMethod,
}
